import { useState } from "react";
import { SearchCodeModalForm } from "src/components/common/form/search/SearchCodeModalForm";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SysCodeDto } from "src/dtos/code/sysCodeDto";
import useUiuxStore from "src/store/useUiuxStore";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import usePUR5020_R01Store, { defaultPUR5020_R01Filter } from "./Store_PUR5020_R01";
import { SearchDateRangeForm } from "src/components/common/form/search/SearchDateRangeForm";
import { SearchSectionDoubleForm } from "src/components/common/form/search/SearchSectionDoubleForm";
import { WareHouseDto } from "src/dtos/warehouse/wareHouseDto";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";

interface Props {}

export const SearchSection_PUR5020_R01 = ({}: Props) => {
	const {
		PUR5020_R01Filter,
		setPUR5020_R01Filter
	} = usePUR5020_R01Store();

	const {
		brandCdList,
		compCdList,
		itemGroupList,
		warehouseCdList,
		itemStatusList,
		wmsCdList
	} = useCommonCodeStore();

	const { setCodeSearchModalProps } = useUiuxStore();
	const [pickerVisible, setPickerVisible] = useState(false);
	const [pickerPosition, setPickerPosition] = useState<{ top: number; left: number }>({ top: 0, left: 0 });

	const handleItemFoucsId = 'itemCd_search';
	const handlePartnerFoucsId = 'partnerCd_search';

	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'itemCd',
			category: '품목코드',
			focusId: handleItemFoucsId,
			responseMapping: { itemCd: 'itemCd', itemNm: 'itemNm' },
			extraFilter: () => ({
				itemCd: PUR5020_R01Filter.itemCd || '',
				itemNm: PUR5020_R01Filter.itemNm || '',
			}),
		},
		{
			fieldName: 'partnerCd',
			category: '거래처',
			focusId: handlePartnerFoucsId,
			responseMapping: { customCd: 'partnerCd', customNm: 'partnerNm' },
			extraFilter: () => ({
				partnerCd: PUR5020_R01Filter.partnerCd || '',
				partnerNm: PUR5020_R01Filter.partnerNm || '',
			}),
		},
	];

	const { getFieldHandlers } = useInfoFormEvents({
		editData: PUR5020_R01Filter,
		setEditData: setPUR5020_R01Filter,
		defaultData: defaultPUR5020_R01Filter,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'PUR5020_R01_search'
	});

	return (
		<div className="w-full">
			<SearchSectionDoubleForm>
				<SearchDropDownForm
					label="사업장"
					value={PUR5020_R01Filter.compCd || 'all'}
					optionList={compCdList}
					onChangeValue={v => setPUR5020_R01Filter({ compCd: v === 'all' ? '' : v })}
				/>
				<SearchDateRangeForm
					label="수불연월"
					visible={pickerVisible}
					setVisible={setPickerVisible}
					dateRange={PUR5020_R01Filter.txDt}
					setDateRange={v => setPUR5020_R01Filter({ txDt: v })}
					pickerPosition={pickerPosition}
					setPickerPosition={setPickerPosition}
				/>
				<SearchDropDownForm<SysCodeDto>
					label="물류센터"
					value={PUR5020_R01Filter.logicCenter || 'all'}
					optionList={wmsCdList}
					onChangeValue={v => setPUR5020_R01Filter({ logicCenter: v === 'all' ? '' : v })}
				/>
				<SearchDropDownForm<WareHouseDto>
					label="창고코드"
					value={PUR5020_R01Filter.warehouseCd || 'all'}
					optionList={warehouseCdList}
					onChangeValue={v => setPUR5020_R01Filter({ warehouseCd: v === 'all' ? '' : v })}
				/>
				<SearchDropDownForm<SysCodeDto>
					label="브랜드"
					value={PUR5020_R01Filter.brandCd || 'all'}
					optionList={brandCdList}
					onChangeValue={v => setPUR5020_R01Filter({ brandCd: v === 'all' ? '' : v })}
				/>
				<SearchCodeModalForm
					label="거래처"
					value={PUR5020_R01Filter.partnerCd}
					valueLabel={PUR5020_R01Filter.partnerNm || ''}
					handleFoucsId={handlePartnerFoucsId}
					onChange={getFieldHandlers('partnerCd').onChange}
					onDoubleClick={getFieldHandlers('partnerCd').onDoubleClick}
					onKeyDown={getFieldHandlers('partnerCd').onEnterKeyDown}
				/>
				
				<SearchDropDownForm<SysCodeDto>
					label="품목그룹"
					value={PUR5020_R01Filter.itemGroup || 'all'}
					optionList={itemGroupList}
					onChangeValue={v => setPUR5020_R01Filter({ itemGroup: v === 'all' ? '' : v })}
				/>
				<SearchCodeModalForm
					label="품목코드"
					value={PUR5020_R01Filter.itemCd}
					valueLabel={PUR5020_R01Filter.itemNm || ''}
					handleFoucsId={handleItemFoucsId}
					onChange={getFieldHandlers('itemCd').onChange}
					onDoubleClick={getFieldHandlers('itemCd').onDoubleClick}
					onKeyDown={getFieldHandlers('itemCd').onEnterKeyDown}
				/>

				<div className="flex items-center gap-2 px-6 py-1">
					<label htmlFor="includeZeroStock_PUR5020" className="text-s cursor-pointer select-none">
						재고0 포함
					</label>
					<input
						type="checkbox"
						id="includeZeroStock_PUR5020"
						checked={PUR5020_R01Filter.includeZeroStock ?? false}
						onChange={(e) => setPUR5020_R01Filter({ includeZeroStock: e.target.checked })}
						className="cursor-pointer"
					/>
				</div>
			</SearchSectionDoubleForm>
		</div>
	);
};
